export default __webpack_public_path__ + "static/media/ic_workflow.3c54f785.svg";